import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseFavoritProduct() {
  const MyAxios = UseCustomAxios();

  const GetFavoritProductReport = (store, newMyPc, bool, callback) => {
    MyAxios.get(`Admin_FavoritProductReport?store=${store}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    GetFavoritProductReport,
  };
}
